export const SITE = {
  name: 'ShieldMyAss',
  domain: 'shieldmyass.xyz',
  url: 'https://www.shieldmyass.xyz',
  tagline: 'Instant No-KYC Crypto Exchange',
  description:
    'ShieldMyAss is a no-KYC, non-custodial crypto exchange. Swap 900+ cryptocurrencies at live market rates with no hidden fees. Bitcoin, Ethereum, Monero, Solana, USDT and more — trades settle in minutes.',
  twitter: '@swapmespace',
  email: 'support@shieldmyass.xyz',
};

export interface SeoMeta {
  title: string;
  description: string;
  path?: string;
  type?: 'website' | 'article';
}

export function buildTitle(page: string): string {
  if (!page) return `${SITE.name} — ${SITE.tagline}`;
  return `${page} · ${SITE.name}`;
}

export function canonicalUrl(path: string = ''): string {
  const clean = path.startsWith('/') ? path : `/${path}`;
  return `${SITE.url}${clean}`;
}
